////////////////////////////////////////////////////
///                                              ///
///   This is a place to extend spec types       ///
///                                              ///
////////////////////////////////////////////////////
export {};
